import HomepageIndex from './homepage-index';

export default class HomepageIndexDesktop extends HomepageIndex {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/homepage/homepage-index.desktop.js